import { render, staticRenderFns } from "./documentation.vue?vue&type=template&id=73f5bac8&lang=en&"
import script from "./documentation.vue?vue&type=script&lang=js&"
export * from "./documentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports